import styled, {css} from "styled-components";

export const PermissionSelectorWrapper = styled.div`
    .confirm-btn {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
    }
    .search {
        max-width: 300px;
    }
    .switch {
        width: 35px;
        height: 22px;
        &::before {
            width: 13px;
            height: 13px;
        }
    }
    .customize-btn {
        box-shadow: none;
        color: ${({theme}) => theme?.light?.primary};
        padding: 0;
        margin-bottom: 25px;
        display: block;
        margin-left: auto;
        display: flex;
        align-items: end;
    }
`;

export const PermissionListGroup = styled.div`
    border: 1px solid rgba(225, 228, 232, 1);
    border-radius: 10px;
`;

export const PermissionListHead = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 20px;
    @media(min-width: 576px){
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    ${({topHead}) =>
        topHead &&
        css`
            border-bottom: 1px solid var(--light-gray);
            border-radius: 5px;
            border: none;
            background: var(--light);
            box-shadow: 0px 8px 10px rgba(176, 183, 195, 0.14);
            flex-direction: row-reverse;
        `}
    .switch-btn {
        max-width: 200px;
        width: 100%;
    }
    > div:first-of-type {
        max-width: 300px;
    }
`;
export const ConfirmButton=styled.div`
    display: flex;
    justify-content: center;
    button{
    width: 100%;
    max-width: 350px;
   }
`;